import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/insurance/InsuranceClient.tsx");
